import { datasetIconName } from "@app/config/constants";
import Icon from "@lib/common/components/Icon/Icon";
import type { ThemeIconProps } from "@mantine/core";
import { ThemeIcon } from "@mantine/core";

export default function DatasetIcon({ size = "sm", ...props }: Partial<ThemeIconProps>) {
  return (
    <ThemeIcon size={size} color="green" radius="sm" variant="filled" {...props}>
      <Icon name={datasetIconName} variant="regular" size={size} />
    </ThemeIcon>
  );
}
